import React from 'react';

export const MarketingAtFingerTips = () => (
  <div className="container mb-8 lg:hidden">
    <p className="text-[#006EB7] font-semibold text-base md:text-xl mb-6">Marketing at your fingertips</p>

    <div className="md:flex md:justify-between md:items-start mb-6">
      <h2 className="text-4xl text-[#0C0D1A] font-semibold md:mb-0 md:max-w-[30rem] lg:max-w-[35rem] md:text-4xl">
        Tailored templates for your needs
      </h2>

      {/* Button 1: Inline with H2 on MD+ (Hidden on mobile) */}
      <a href="/professionals/resources/marketing-toolkit/request-toolkit"
        className="hidden md:inline-block default-button-primary-large md:whitespace-nowrap text-center"
      >
        Request a toolkit
      </a>
    </div>

    <p className="text-base text-[#5B5D6B] font-450 mb-6 xl:w-[35rem]">
      Promote your business and reach new clients with our print and digital marketing templates. Hover over the items
      to get a sneak peek of our ready-made resources and click the button to see more detailed examples.
      You can maximise your toolkit allowance with our ready-made print, digital and mixed bundles.
    </p>

    {/* 2. Button (Underneath P on Mobile, Hidden on MD+) */}
    <a href="/professionals/resources/marketing-toolkit/request-toolkit"
      className="block md:hidden default-button-primary-large w-full mx-auto text-center"
    >
      Request a toolkit
    </a>
  </div>
);
